import cn from 'classnames';
import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';
import React from 'react';

import Row from 'components/basic/PlansInfoTable/Row';
import { tableTexts } from 'components/basic/PlansInfoTable/constants';
import { H2 } from 'components/basic/Typography';

import s from './PlansInfoTable.module.scss';

export default function PlansInfoTable(): JSX.Element {
  const t = useTranslationAndTypograph();
  const tables = tableTexts.map(table => {
    const rows = table.items.map(({ text, allowInFree }) => (
      <Row key={text} text={t(text)} allowInFree={allowInFree} />
    ));

    return (
      <div key={table.header} className="mb-8">
        <H2 className={cn(s.h2, 'mb-6')}>{t(table.header)}</H2>
        {rows}
      </div>
    );
  });

  return (
    <div className={s.wrapper}>
      <div className={cn(s.row, s.headerRow, 'mb-12')}>
        <span className={s.headerCol}>{t('What you get')}</span>
        <span className={s.headerCol}>{t('Free')}</span>
        <span className={cn(s.headerCol, s.headerColPro)}>
          <span>{t('Premium')}</span>
        </span>
      </div>
      {tables}
    </div>
  );
}
